export const APPLICATION_STATUS = {
  PENDING: 'pending',
  IN_PROCESS: 'in-process',
  INTERVIEW_SCHEDULED: 'interview_scheduled',
  APPROVED: 'approved',
  REJECTED: 'rejected',
};

export const CANDIDATE_BUCKET = {
  APPLIED: 'applied',
  SCHEDULED: 'scheduled',
  REJECTED: 'rejected',
};

export const CANDIDATE_STATUS = {
  APPLIED: 'applied',
  SCHEDULED: 'scheduled',
  REJECTED: 'rejected',
};
